import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import AppWrapper from './template/AppWrapper';

import {UserProvider} from './common';

const IntelApp = () => {

  

  return (<UserProvider>
    <BrowserRouter>
    {/* <h1>Hi</h1> */}
      <AppWrapper />
    </BrowserRouter>
  </UserProvider>);
}

ReactDOM.render(
  <IntelApp />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
